// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZH0n","tabsBox":"styles_tabsBox__2LT0l","createButton":"styles_createButton__13EPo"};